<template>
  <section class="prizes">
    <div class="competition-prizes" id="competition-prizes">
      <div class="prize-container">
        <div
          class="prize"
          @click="
            openLink(
              'https://www.nokia.com/phones/en_int/nokia-8110-4g'
            )
          "
        >
          <div class="bubble" ref="prizeBubble" v-if="!competitionEnded">
            <p>What can I win?</p>
          </div>
          <div class="prize-place">
            <!-- <span>1<sup>st</sup></span> - <span>3<sup>rd</sup></span> -->
            Top 3
          </div>
          <div class="prize-image">
            <img src="@/assets/nokia-8110.png" alt="1st Prize - Nokia 8110 4g" />
          </div>
          <div class="prize-description">
            <p>
              Nokia 8110
              <br />(Matrix phone)
            </p>
          </div>
        </div>

        <div class="prize">
          <div class="prize-place">
            <!-- <span>2<sup>nd</sup></span> -->
            Top 10
          </div>
          <div class="prize-image">
            <img class="amazon-img" src="@/assets/amazon.png" alt="2nd Prize - 20$ Amazon Voucher" />
          </div>
          <div class="prize-description">
            <p>
              $20 Amazon
              <br />voucher
            </p>
          </div>
        </div>

        <div class="prize" @click="openLink('https://covve.com/cardscanner/')">
          <div class="prize-place">
            <!-- <span>3<sup>rd</sup></span> -->
            Top 30
          </div>
          <div class="prize-image">
            <img
              class="covve-scan-img"
              src="@/assets/covve-scan.png"
              alt="3rd Prize - Covve Business card scanner lifetime access"
            />
          </div>
          <div class="prize-description">
            <p>
              Business card scanner
              <br />Lifetime access
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { trackEvent } from "@/analytics";
export default {
  props: ["competitionEnded"],
  methods: {
    openLink(link) {
      trackEvent("sawprize");
      window.open(link, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
section.prizes {
  // make it look centered
  .covve-scan-img {
    margin: 25px 0 0 30px;
  }

  text-align: center;
  margin: 200px 0 80px;
  position: relative;

  .competition-prizes {
    .bubble {
      padding: 0 13px;
      position: absolute;
      top: -100px;
      left: 25px;
      display: inline-block;
      border: 17px solid white;
      border-image-source: url("../../assets/chat-bubble.svg");
      border-image-slice: 16 15 32 15;
      color: white;
      p {
        margin-bottom: 10px;
      }

      transition: 100ms ease-in-out;
      &:hover {
        transform: translateY(-10px);
      }
    }

    .prize-container {
      // margin: 50px;
      display: flex;
      justify-content: center;
      // flex-wrap: wrap;

      .prize {
        margin: 15px;
        position: relative;
        background-image: url("../../assets/frame-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        min-height: 388px;
        max-width: 348px;
        flex: 1 1 242px;

        // min-width: 348px;
        .prize-place {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 20px;
          left: 28px;
          font-size: 0.7rem;
          background-color: #140425;
          border-radius: 10px;
          max-width: 150px;
          padding: 5px 10px;
          height: 40px;
          sup {
            font-size: 0.5rem;
          }
        }
        .prize-image {
          width: 100%;
          height: 80%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 100ms ease-in-out;
          img {
            min-width: 100px;
            max-width: 60%;
            max-height: 200px;
          }
        }
        .prize-description {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          height: 17%;
          font-size: 0.8rem;
          span.smaller {
            font-size: 0.5rem;
          }
        }

        &:hover {
          color: $accent-color;
          cursor: pointer;
          .prize-image {
            transform: scale(1.06) translateY(-15px);
          }
        }
      }
    }
  }
}

.prize-link {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}

@media (max-width: 768px) {
  section.prizes {
    margin: 90px 0 60px;
  }
  section.prizes .competition-prizes .prize-container {
    flex-wrap: wrap;
    .prize {
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  section.prizes
    .competition-prizes
    .prize-container
    .prize
    .description
    span.smaller {
    font-size: 0.6rem;
  }

  .amazon-img {
    width: 182px;
    height: 118px;
  }
  // section.prizes .competition-prizes .prize-container .prize {
  //   margin-right: 0px;
  //   margin-left: 0px;
  //   min-width: 300px;
  //   background-size: 100% 100%;
  // }
}
</style>